module.exports = __webpack_public_path__ + "assets/img/description_active.3ea82e6a.png";